'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _changeCurrentBlockType = require('../../customRichUtils/changeCurrentBlockType');

var _changeCurrentBlockType2 = _interopRequireDefault(_changeCurrentBlockType);

var _updateBlockMetadata = require('../../customRichUtils/updateBlockMetadata');

var _updateBlockMetadata2 = _interopRequireDefault(_updateBlockMetadata);

var _draftjsConstants = require('../../draftjsConstants');

var _checklistConstants = require('./checklistConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Match the start of the string followed by [ ] or [] or [x]


// Constants
// Utils
var CHECKLIST_MARKDOWN_PATTERN = /^(\[ \]|\[\]|\[x\])$/i;

// TODO Maybe move this into the markdown plugin

exports.default = function (char, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;

    if (char !== ' ') return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;

    var editorState = getEditorState();

    // TODO Use the code from markdown
    var currentSelection = editorState.getSelection();
    var key = currentSelection.getStartKey();
    var block = editorState.getCurrentContent().getBlockForKey(key);
    var text = block.getText();
    var position = currentSelection.getAnchorOffset();
    var lineBeforeCharacter = text.slice(0, position);
    var lineAfterCharacter = text.slice(position);

    if (lineBeforeCharacter.match(CHECKLIST_MARKDOWN_PATTERN)) {
        var updatedEditorState = (0, _changeCurrentBlockType2.default)(editorState, _checklistConstants.CHECKLIST_BLOCK_TYPE, lineAfterCharacter);

        if (lineBeforeCharacter === '[x]' || lineBeforeCharacter === '[X]') {
            // TODO Figure out if this should be immutable
            updatedEditorState = (0, _updateBlockMetadata2.default)(updatedEditorState, block, { checked: true });
        }

        setEditorState(updatedEditorState);
        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
    }

    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/handleBeforeInput.js
// module id = 1722
// module chunks = 0